import { useQuery } from '@apollo/client';
import { GET_LISTING_AVERAGE_SELLING_TIME_FOR_CAR_BODIES } from 'apollo-client/queries/getListingAverageSellingTimeForCarBodies';
import { HorizontalBarGraph } from 'components/HorizontalBarGraph';
import { GetListingAverageSellingTimeForCarBodiesRequest, Query } from 'generated/graphql';
import { useIntl } from 'react-intl';

export const SellingTimeForCarBodiesChart: (p: { vendorNames: Array<string> }) => JSX.Element | null = ({
  vendorNames,
}) => {
  const { formatMessage } = useIntl();
  const { loading, data } = useQuery<Query, GetListingAverageSellingTimeForCarBodiesRequest>(
    GET_LISTING_AVERAGE_SELLING_TIME_FOR_CAR_BODIES,
    { variables: { vendorNames } }
  );
  return (
    <HorizontalBarGraph
      loading={loading}
      color="PRIMARY"
      barSeriesName={formatMessage({ id: 'averageSellingTimeForCarBodies' })}
      title={formatMessage({ id: 'averageSellingTimeForCarBodies' })}
      data={
        data?.getListingAverageSellingTimeForCarBodies?.map(({ carBody, sellingTimeInDays }) => ({
          x: carBody,
          y: sellingTimeInDays,
        })) || []
      }
    />
  );
};
